const standardPowerupsData = [
	{
		"name" : "Ring Return",
		"description" : "Bring back a retired superstar who is not a hall-of-famer for one more match.",
		"cost" : 130,
		"effect" : "retirement_return",
		"level" : 1,
		"selection" : "retired_superstars",
		"rarity" : 90,
		"storyName" : null
	},
	{
		"name" : "Ring Return+",
		"description" : "Bring back a retired hall-of-famer for one last legendary match.",
		"cost" : 160,
		"effect" : "retirement_return",
		"level" : 2,
		"selection" : "retired_superstars",
		"rarity" : 105,
		"storyName" : null
	},
	{
		"name" : "Ring Return++",
		"description" : "Stage a miraculous, full-time comeback for a retired superstar.",
		"cost" : 400,
		"effect" : "retirement_return",
		"level" : 3,
		"selection" : "retired_superstars",
		"rarity" : 350,
		"storyName" : null
	},
	{
		"name" : "Callup",
		"description" : "Callup a training superstar to the main roster.",
		"cost" : 100,
		"effect" : "callup",
		"level" : 1,
		"selection" : "training_superstars",
		"rarity" : 80,
		"storyName" : null
	},
	{
		"name" : "Re-sign",
		"description" : "Convince a part-time superstar to sign on for more appearances.",
		"cost" : 150,
		"effect" : "part_timer_appearances",
		"level" : 1,
		"selection" : "part_time_superstars",
		"rarity" : 100,
		"storyName" : null
	},
	{
		"name" : "Wolverine",
		"description" : "Speed up the return of an injured superstar who is in the later stages of recovery.",
		"cost" : 120,
		"effect" : "early_return",
		"level" : 1,
		"selection" : "returning_superstars",
		"rarity" : 95,
		"storyName" : null
	},
	{
		"name" : "Callup+",
		"description" : "Stage a takeover, calling up multiple training superstars or a faction to the main roster.",
		"cost" : 250,
		"effect" : "callup",
		"level" : 2,
		"selection" : "training_factions",
		"rarity" : 225,
		"storyName" : null
	},
	{
		"name" : "Mega Show",
		"description" : "Hold more events than usual at the upcoming show.",
		"cost" : 70,
		"effect" : "increase_matches",
		"level" : 1,
		"selection" : null,
		"rarity" : 60,
		"storyName" : null
	},
	{
		"name" : "Recruitment",
		"description" : "Hold a tryout, recruiting new talent to join your training roster.",
		"cost" : 90,
		"effect" : "recruitment",
		"level" : 1,
		"selection" : null,
		"rarity" : 75,
		"storyName" : null
	},
	{
		"name" : "Step Up",
		"description" : "Get the owner of the company or a manager to step into the ring and wrestle.",
		"cost" : 170,
		"effect" : "one_match",
		"level" : 1,
		"selection" : "owner_and_managers",
		"rarity" : 120,
		"storyName" : null
	},
	{
		"name" : "Hypnosis",
		"description" : "Convince the owner of the company to change an incomplete goal.",
		"cost" : 200,
		"effect" : "reroll_goal",
		"level" : 1,
		"selection" : "objectives",
		"rarity" : 200,
		"storyName" : null
	},
	{
		"name" : "Training",
		"description" : "Send a superstar to the training roster to improve their popularity.",
		"cost" : 80,
		"effect" : "send_to_training",
		"level" : 1,
		"selection" : "superstars_except_champions",
		"rarity" : 70,
		"storyName" : null
	},
	{
		"name" : "Style Change",
		"description" : "Convince the company directors to change the company's style.",
		"cost" : 120,
		"effect" : "style_change",
		"level" : 1,
		"selection" : null,
		"rarity" : 95,
		"storyName" : null
	},
	{
		"name" : "Re-sign+",
		"description" : "Convince a part-time superstar to sign on full-time with the company.",
		"cost" : 320,
		"effect" : "part_timer_appearances",
		"level" : 2,
		"selection" : "part_time_superstars",
		"rarity" : 270,
		"storyName" : null
	},
	{
		"name" : "Reincarnation",
		"description" : "Bring back a random gimmick from a superstar's past.",
		"cost" : 80,
		"effect" : "random_past_gimmick",
		"level" : 1,
		"selection" : "past_gimmick_superstars",
		"rarity" : 65,
		"storyName" : null
	},
	{
		"name" : "Roulette",
		"description" : "Run a gimmick match roulette, adding a random gimmick to the match.",
		"cost" : 60,
		"effect" : "gimmick_match_roulette",
		"level" : 1,
		"selection" : "matches",
		"rarity" : 55,
		"storyName" : null
	},
	{
		"name" : "Staff Interest",
		"description" : "Hold a job ad, getting professionals to list themselves on the Staff Hiring Board.",
		"cost" : 130,
		"effect" : "staff_recruitment",
		"level" : 1,
		"selection" : "",
		"rarity" : 90,
		"storyName" : null
	},
	{
		"name" : "Interbrand+",
		"description" : "Allow superstars from other brands to be booked on all shows up to the next monthly event.",
		"cost" : 220,
		"effect" : "allow_other_brands_extended",
		"level" : 2,
		"selection" : null,
		"rarity" : 200,
		"storyName" : null
	},
	{
		"name" : "Interbrand",
		"description" : "Allow superstars from other brands to be booked at the upcoming show.",
		"cost" : 100,
		"effect" : "allow_other_brands",
		"level" : 1,
		"selection" : null,
		"rarity" : 85,
		"storyName" : null
	},
	{
		"name" : "Cyborg",
		"description" : "Replace an injured body part using synthetic materials, instantly healing the injury.",
		"cost" : 130,
		"effect" : "instant_heal",
		"level" : 1,
		"selection" : "injured_superstars",
		"rarity" : 100,
		"storyName" : "mars"
	},
	{
		"name" : "Neural Control",
		"description" : "Remove negative emotions from a superstar using a neural control interface.",
		"cost" : 120,
		"effect" : "happy",
		"level" : 1,
		"selection" : "unhappy_superstars",
		"rarity" : 95,
		"storyName" : "mars"
	},
	{
		"name" : "Neural Control+",
		"description" : "Hide a neural control device in a competitor's company, implanting the superstar who uses it with a desire to leave and join your company.",
		"cost" : 500,
		"effect" : "superstar_jump",
		"level" : 2,
		"selection" : "competitors",
		"rarity" : 450,
		"storyName" : "mars"
	}
];

export {standardPowerupsData}